module.exports = __webpack_public_path__ + "img/yszc-gszc-jyfw.706f67f3.png";